// src/features/roles/signalementInvite.ts — SCE Issues
// Un compte invité (hors @sartorius.com : iPad partagé, téléphone personnel)
// qui ouvre l'appli se signale dans le bloc `invitesVus` de la ligne
// __global__, une fois par jour et par appareil. Le panneau d'administration le
// propose ensuite pour un appareil partagé ou un compte secondaire : plus
// besoin de demander l'identifiant à l'IT (22/10).
//
// Au mieux : un échec ne gêne rien (réessayé à la prochaine ouverture).

import { useEffect } from 'react'
import { useAuth } from '@/auth/useAuth'
import { objectIdDuCompte } from '@/auth/identiteCompte'
import { modifierBlocGlobal } from '@/api/reglagesGlobaux.api'
import { adresseNormalisee } from '@/config/comptesAlias.config'
import { sha256Hex } from '@/utils/empreinte'
import { CLE_BLOC_INVITES_VUS, estCompteInvite, noterInviteVu } from '@/utils/roles'

const CLE_DERNIER = 'sce-issues.invite-signale'
const UN_JOUR_MS = 24 * 3600 * 1000

export function SignalementInvite(): null {
  const { account } = useAuth()
  useEffect(() => {
    if (!account || !estCompteInvite(account.username)) return
    const objectId = objectIdDuCompte(account)
    if (!objectId) return
    try {
      const dernier = Number(localStorage.getItem(`${CLE_DERNIER}:${objectId}`) ?? 0)
      if (Date.now() - dernier < UN_JOUR_MS) return
    } catch {
      // Stockage indisponible : on signale à chaque ouverture, sans dommage.
    }
    const vu = {
      objectId,
      nom: account.name ?? '',
      empreinteAdresse: sha256Hex(adresseNormalisee(account.username)),
      le: new Date().toISOString(),
    }
    modifierBlocGlobal(CLE_BLOC_INVITES_VUS, (bloc) => noterInviteVu(bloc, vu))
      .then(() => {
        try {
          localStorage.setItem(`${CLE_DERNIER}:${objectId}`, String(Date.now()))
        } catch {
          // Rien à garder : on resignalera.
        }
      })
      .catch((err: unknown) => {
        // eslint-disable-next-line no-console
        console.warn('[roles] compte invité non signalé', err)
      })
  }, [account])
  return null
}
